import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    startRecording: {
        loading: false,
        data: false,
        error: false,
    },
    stopRecording: {
        loading: false,
        data: false,
        error: false,
    },
    recordingBtnEnabled: true,
    recordingON: false,
    recordInProcess: false,
    startRecReceived: false,
    recordingErrorView: false,
    recordingInfoOnLoad: false,
};
const recordingReducerSlice = createSlice({
    name: "recordingReducer",
    initialState,
    reducers: {
        updateRecordingStatus(state, action) {
            const { recordingType, loading = false, data = false, error = false, reset = false } = action.payload;
            if (recordingType === "startRecording" && reset) {
                return {
                    ...state,
                    startRecording: initialState.startRecording,
                };
            } else if (recordingType === "stopRecording" && reset) {
                return {
                    ...state,
                    stopRecording: initialState.stopRecording,
                };
            }
            state[recordingType].loading = loading;
            state[recordingType].data = data;
            state[recordingType].error = error;
        },
        setRecordingBtnEnabled(state, action) {
            state.recordingBtnEnabled = action.payload;
        },
        setRecordingON(state, action) {
            state.recordingON = action.payload;
        },
        setRecordInProcess(state, action) {
            state.recordInProcess = action.payload;
        },
        setStartRecReceived(state, action) {
            state.startRecReceived = action.payload;
        },
        setRecordingErrorView(state, action) {
            state.recordingErrorView = action.payload;
        },
        setRecordingInfoOnLoad(state, action) {
            state.recordingInfoOnLoad = action.payload;
        },
        resetRecordingReducer() {
            return initialState;
        },
    },
});

export const {
    updateRecordingStatus,
    setRecordingBtnEnabled,
    setRecordingON,
    setRecordInProcess,
    setStartRecReceived,
    setRecordingErrorView,
    setRecordingInfoOnLoad,
    resetRecordingReducer,
} = recordingReducerSlice.actions;
export default recordingReducerSlice.reducer;
